import { Typography } from "@mui/material";
import { slateToHtml, payloadSlateToDomConfig } from 'slate-serializers'
export function RenderOutput({output}) {
  const serializedToHtml = slateToHtml(output, payloadSlateToDomConfig)
  return (
    <>
      {output && <Typography dangerouslySetInnerHTML={{__html:serializedToHtml}}/>}
    </>
  );
}